import {API_URL} from "./index";

export async function apiJoinWaitlist(email) {
    const res = await fetch(`${API_URL}/waitlist`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({email}),
    });
    return res.json();
}

export async function apiGetCompleteRegistration(token) {
    const res = await fetch(`${API_URL}/complete-registration/${token}`);
    return res.json();
}

export async function apiCompleteRegistration(token, username, password, cguAccepted) {
    const res = await fetch(`${API_URL}/complete-registration/${token}`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({username, password, cguAccepted}),
    });
    return res.json();
}
